import { Schema } from "effect";

export const Email = Schema.String.pipe(
  Schema.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, {
    message: () => "Invalid email address",
  })
);

export const Password = Schema.String.pipe(
  Schema.minLength(8, {
    message: () => "Password must be at least 8 characters",
  })
);

export const Url = Schema.String.pipe(
  Schema.filter(
    (s) => {
      try {
        new URL(s);
        return true;
      } catch {
        return false;
      }
    },
    { message: () => "Invalid URL format" }
  )
);

export const SentryDsn = Schema.Union(
  Url,
  Schema.Literal("")
);
